var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{attrs:{"name":"loader-effect"}},[(_vm.$store.state.pageLoader.loading)?_c('div',{attrs:{"id":"page-loader"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }